<template>
  <div class='CardProdutoReceita'>
    <img class='imagem' :src='imagem' :alt='descricao'>
    <div class='info'>
      <div class='descricao' :title='descricao'>{{ descricao }}</div>
      <div class='valor'>{{ valorFormatado }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardProdutoReceita',
  props: {
    imagem: { type: String, default: '' },
    descricao: { type: String, required: true },
    valorReceita: { type: Number, required: true }
  },
  computed: {
    valorFormatado () {
      return this.valorReceita.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  }
}
</script>

<style scoped>
.CardProdutoReceita {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #e5e5e5;
}
.CardProdutoReceita:last-child {
  border-bottom: none;
}
.imagem {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  object-fit: contain;
}
.info {
  min-width: 0;
  flex: 1;
}
.descricao {
  font-size: 12px;
  color: #303030;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.valor {
  margin-top: 4px;
  font-size: 15px;
  color: #303030;
}
</style>
